export const CD_TICKET_LINK = 'https://t.corp.amazon.com/create/templates/42098ba4-6f97-4328-bee7-40a361457e57';
